import React from "react"
import { Link } from "gatsby"

import DefaultImag from "../../assets/img/default_pic.jpg"
import Img from "gatsby-image";
import BackgroundImage from "gatsby-background-image"
import GetImgUrl, {isSlugExisting} from "../../utils/customFunctions"
import { removeSlashFromSlug } from '../../utils/additionalFunctions';


var bgFluidImage = {fluid: {srcWebp: "/static/15c09c2e1b61bb9beff993549ed1980c/a4666/Marble_1af090ae41_43ac8eae86.webp", src: "/static/15c09c2e1b61bb9beff993549ed1980c/c122a/Marble_1af090ae41_43ac8eae86.jpg"}}


const ImageCard = ({img, title, description, label, url, type, data, price, quantity, removeFromCart}) => {
   
//    let urlSlug = isSlugExisting(data.node.slug)

    var fluidBG = null
    if(data.Background && data.Background.localFile___NODE){
        fluidBG = GetImgUrl(data.Background.localFile___NODE).fluid
    }else{
        if(data.Background){
            fluidBG = data.Background.localFile.childImageSharp.fluid
        }else{
            fluidBG = {
                srcWebp: process.env.GATSBY_DEFAULT_NA_IMAGE,
                src: process.env.GATSBY_DEFAULT_NA_IMAGE
            }
        }
        
        
    }


    switch (type) {
        case "normal":
            // const style = {backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.9)), url(` + (data.Background?data.Background.url:DefaultImag) + `)`}
            
            return(
                <div className=" ">
              
              <Link to={data.url.substring(0,4) === 'http' ? data.url: '/' + (data.url).replace(/^\//, "")}>
                    <BackgroundImage
                        Tag="section"
                        fluid={fluidBG}
                        backgroundColor={`#040e18`} 
                        role="img"
                        aria-label={data.Title}
                        keepStatic="true"
                       >
                        <div className="header-container-gradient ">
                            <div className="image-card-tiles uk-tile uk-background-cover cta-big-tile" >
                                <div>
                                    <div className="uk-card-body">
                                        <div className="card-link ">{data.Title}</div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </BackgroundImage>
                </Link> 
                </div>
            )
        
        case "horizontal":
            return(
                <div className='horizontal_card_wrapper '>

               
                    
                   

                    <div className='text_container'>
                        <div className="first-item-content ">
                            <h3 className=" card-title">{data.node?.Title}</h3>
                            {/* <p className="card-description"></p> */}
                            
                            <Link to={`${url}/${data.node?.slug}`}  className="card-link ">{data.node?.Date}</Link>
                        </div>
                    </div>

                    <div className="img__container ">
                     <Img fluid={data.node?.Header.Background?.localFile?.childImageSharp.fluid} alt={data.node?.Title} className='horizontal-image' ></Img>
                    </div>
                    
                
                </div>
            )
      
        // case "horizontal":
        //     return(
        //         <div className='horizontal-card-wrapper lateral-padding'>

        //         <div className="uk-grid-small   uk-child-width-1-1@s uk-padding-remove" data-uk-grid>
        //         <div className='horizontal-card-container uk-padding-remove'>      
        //             <div className="last-item ">
        //              <Img fluid={data.node?.Header.Background?.localFile?.childImageSharp.fluid} alt={data.node?.Title} className='horizontal-image' ></Img>
        //             </div>

        //             <div className='first-item '>
        //                 <div className="first-item-content ">
        //                     <h3 className=" card-title">{data.node?.Title}</h3>
        //                     <p className="card-description"></p>
                            
        //                     <Link to={`${url}/${data.node?.slug}`}  className="card-link ">{data.node?.Date}</Link>
        //                 </div>
        //             </div>

        //         </div>
                    
        //         </div>
        //         </div>
        //     )
      
       
        
        case "checkout-horizontal":
            return(
                <div className="image-card uk-card uk-card-default uk-grid-collapse lateral-padding" data-uk-grid>
                    <div className="uk-flex-first@s  uk-cover-container uk-width-1-4@m">
                        <img src={DefaultImag} alt="" data-uk-cover></img>
                        {/* <canvas width="100" height="100"></canvas> */}
                    </div>
                    <div className="uk-width-3-4@m">
                        <div className="checkout-prod-details">
                        
                            <h3 className="uk-card-title card-title">{title?title:"default title"}</h3>
                            {/* <p className="card-description">X</p> */}
                            
                            {/* <a href="#0" className="card-link ">12 Apr 2021</a> */}
                            
                            {/* <div className="product-quantity">Qty.
                                <button>-</button>
                                <span>{quantity?quantity:"N/A"}</span>
                                <button>+</button>
                            </div> */}
                            <div className="">£{price?price:"N/A"}</div>
                            
                        </div>
                        
                    </div>
                    {/* <button onClick={() => pageData.removeFromCart(data)} className="uk-position-top-right delete-button" data-uk-close aria-label="close-button"></button> */}
                </div>
            )


        
        default :
            return("")

    }
    
}

export default ImageCard